import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { projectsCopyLinkStart } from "Store/Actions";
import { selectSelectedOrActiveProjectIds } from "Store/Selectors/Projects";
import { hasElements } from "Utils/Array";
import { IAction } from "./IAction";

export function useCopyProjectLink(): [boolean, IAction] {
  const dispatch = useDispatch();
  const selectedProjects = useSelector(selectSelectedOrActiveProjectIds);
  const allowCopy = hasElements(selectedProjects) && selectedProjects.length === 1;

  const onCopyProjectLink = useCallback(() => {
    if (!allowCopy) {
      return;
    }

    dispatch(projectsCopyLinkStart());
  }, [allowCopy, dispatch]);

  return [allowCopy, onCopyProjectLink];
}
